module.exports = __webpack_public_path__ + "img/icon-nature-tab.dde87b36.png";